import React from "react";
import { useLocation } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";
import { findRoutePermission } from "../../auth/permissions";
import PermissionDenied from "./PermissionDenied";

const RoutePermissionGate = ({ children, capability, minLevel = "R" }) => {
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const required = capability
    ? { capability, minLevel }
    : findRoutePermission(location.pathname);

  const allowed = !required
    ? true
    : required.anyOf?.length
      ? required.anyOf.some((option) => hasPermission(option.capability, option.minLevel || "R"))
      : hasPermission(required.capability, required.minLevel || "R");

  if (!allowed) {
    return <PermissionDenied />;
  }

  return children;
};

export default RoutePermissionGate;
